import React from "react";
import { useTranslation } from "react-i18next";
import Modal from "../../../../parts/modal-new";
import { useRillContext } from "../../../../rill/RillReact/share/base";

function ConfirmStopTraining(props) {
  const { locals } = useRillContext();

  const {
    athlete,
    activeUser,
    coachOrganizationInformation = undefined,
    query,
  } = locals;
  const { t } = useTranslation(["athlete-portal", "common"]);
  const referAsClients = Boolean(activeUser.referAsClients);
  const entity = t(referAsClients ? "programs.client" : "programs.athlete");
  return (
    <form
      action={`/actions/user/stop-training/${athlete._id}`}
      method="POST"
      data-noreset
    >
      <Modal
        width="600px"
        title={t("profile.stopTraining")}
        className={"stop-training-modal"}
      >
        <div className="body">
          <div className="columns">
            <div className="column" data-col="1/1">
              <b>{t("confirmStopTraining.pleaseAcknowledge", { entity })}</b>
              {/* init of hidden input that has the organizationCoach value */}
              <div>
                <input
                  id="coachOrganizationInformation"
                  name="coachOrganizationInformation"
                  defaultValue={JSON.stringify(coachOrganizationInformation)}
                  style={{ display: "none" }}
                />
              </div>
              {/* end of hidden input */}
              <div>
                <input
                  type="checkbox"
                  id="stop-training-push-confirm"
                  name="acknowledge"
                  value="push"
                />
                <label htmlFor="stop-training-push-confirm">
                  {t("confirmStopTraining.noPushPrograms", { entity })}
                </label>
              </div>
              <div>
                <input
                  type="checkbox"
                  id="stop-training-programs-confirm"
                  name="acknowledge"
                  value="programs"
                />
                <label htmlFor="stop-training-programs-confirm">
                  {t("confirmStopTraining.stillHavePrograms", { entity })}
                </label>
              </div>
              <div>
                <input
                  type="checkbox"
                  id="stop-training-list-confirm"
                  name="acknowledge"
                  value="list"
                />
                <label htmlFor="stop-training-list-confirm">
                  {t("confirmStopTraining.stillHaveProfile", { entity })}
                </label>
              </div>
              <div>
                <input
                  type="checkbox"
                  id="stop-training-calendar"
                  name="acknowledge"
                  value="list"
                />
                <label htmlFor="stop-training-calendar">
                  {t("confirmStopTraining.noCalendarMetrics", { entity })}
                </label>
              </div>
              <div>
                <input
                  type="checkbox"
                  id="stop-training-billing"
                  name="acknowledge"
                  value="list"
                />
                <label htmlFor="stop-training-billing">
                  {t("confirmStopTraining.noBilling", { entity })}
                </label>
              </div>
            </div>
          </div>
        </div>

        <footer>
          <a
            role="button"
            data-button-type="secondary"
            data-action="cancel"
            href="/actions/refresh?modal="
          >
            {t("common:cancel")}
          </a>
          <button data-button-type="primary" type="submit">
            {t("profile.stopTraining")}
          </button>
        </footer>
      </Modal>
    </form>
  );
}

export default ConfirmStopTraining;
